import { CButton } from '@coreui/react';
import * as React from 'react';

interface IProps {
	onImageSubmit?: (data: string) => void;
}

interface IState {
	pen: 'down' | 'up',
	penCoordsX: number,
	penCoordsY: number,
	isOpen: boolean
}

// Objet permettant de dessiner (pour signer généralement) en plein écran
// Génère une image JPG
export class KDrawing extends React.Component<IProps, IState> {
	canvaRef: React.RefObject<HTMLCanvasElement>;

	constructor(props) {
		super(props);

		this.canvaRef = React.createRef<HTMLCanvasElement>();

		this.state = {
			pen: 'up',
			penCoordsX: 0,
			penCoordsY: 0,
			isOpen: false
		}
	}

	screenWidth: number;
	screenHeight: number;

	//#region React Events

	componentDidMount = () => {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;

		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount = () => {
		window.removeEventListener('resize', this.updateDimensions);
	}

	//#endregion 

	//#region Local events

	// Resize de fenêtre, on met à jour les dimensions 
	updateDimensions = () => {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		this.forceUpdate();
	};

	ctx: CanvasRenderingContext2D;

	// Appelé si clik sur zone canvas
	// Si le pen est 'down', on dessine
	drawing = (e) => {
		if (this.state.pen === 'down') {

			let ctx = this.ctx;
			ctx.beginPath();
			ctx.lineWidth = 5;
			ctx.lineCap = 'round';

			ctx.moveTo(this.state.penCoordsX, this.state.penCoordsY)	//move to old position
			ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY)		//draw to new position
			ctx.stroke();

			this.setState({
		    penCoordsX: e.nativeEvent.offsetX,
			penCoordsY: e.nativeEvent.offsetY
			})
		}
	}

	// Descend le stylo sur la feuille
	penDown = (e) => {
		this.setState({
			pen: 'down',
			penCoordsX: e.nativeEvent.offsetX,
			penCoordsY: e.nativeEvent.offsetY
		})
	}

	// Remonte le stylo
	penUp = () => { //mouse is up on the canvas
		this.setState({ pen: 'up' })
	}

	// Réinitialise la zone de dessin
	resetCanvas = () => {
		this.setState({ pen: 'up', })
		let ctx = this.ctx;
		ctx.fillStyle = "white";
		ctx.fillRect(0, 0, this.screenWidth - 60, this.screenHeight - 110);
		ctx.lineWidth = 5;
	}

	// Active le canvas (en plein écran) et démarre donc la séance de "dessiner c'est gagné"
	startDraw = () => {
		this.setState({ isOpen: true }, () => {
			this.ctx = this.canvaRef.current.getContext("2d");
			this.resetCanvas();
		})
	}

	// Ferme le panel 
	stopDraw = () => {
		this.setState({ isOpen: false })
	}

	// Click sur le bouton cancel
	onCancelClick = () => {
		this.stopDraw();
	}

	// Click sur ok => on récupère l'image et on la transmet à l'appelant
	onOkClick = () => {
		this.stopDraw();
		let image = this.canvaRef.current.toDataURL('image/jpeg', 0.9);
		if (this.props.onImageSubmit) this.props.onImageSubmit(image);
	}

	//#endregion Local events

	//#region Rendus

	renderCanvas = () => {
		if (!this.state.isOpen) return "";

		return (
			<div className="KDrawingWrapper">
				<div className="KDrawing">
					<canvas ref={this.canvaRef} width={this.screenWidth - 60} height={this.screenHeight - 110}
						onMouseMove={(e) => this.drawing(e)}
						onMouseDown={(e) => this.penDown(e)}
						onMouseUp={(e) => this.penUp()}
						onMouseLeave={(e) => this.penUp()}
					/>
					<div className="controls">
						<CButton size="lg" color="success" onClick={() => { this.onOkClick() }}>✓ OK</CButton>
						<CButton size="lg" color="danger" onClick={() => { this.onCancelClick() }}>✖ Annuler</CButton >
						<CButton size="lg" color="primary" onClick={() => { this.resetCanvas() }}>⎚ Effacer</CButton >
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className="KDrawingInput">
				{this.renderCanvas()}
				<CButton onClick={() => { this.startDraw(); }} >🖋</CButton>
			</div>
		)
	}

	//#endregion

}

